import { getRuleErrorMessage, URLRegex } from "@/utils/formHelper";
import { qrNameValidation } from "./shared";
import { TFunction } from "i18next";

export const qrImagesValidation = (data, t: TFunction) => {
  return [
    qrNameValidation(t),
    {
      name: "albumTitle",
      rules: {
        maxLength: {
          value: 100,
          message: getRuleErrorMessage("albumTitle", "maxLength", data),
        },
      },
    },
    {
      name: "albumDescription",
      rules: {
        maxLength: {
          value: 100,
          message: getRuleErrorMessage("albumDescription", "maxLength", data),
        },
      },
    },
    {
      name: "albumWebsite",
      rules: {
        pattern: {
          value: new RegExp(URLRegex),
          message: getRuleErrorMessage("albumWebsite", "pattern", data),
        },
      },
    },
    {
      name: "buttonText",
      rules: {
        maxLength: {
          value: 50,
          message: getRuleErrorMessage("buttonText", "maxLength", data),
        },
      },
    },
    {
      name: "buttonUrl",
      rules: {
        pattern: {
          value: new RegExp(URLRegex),
          message: getRuleErrorMessage("buttonUrl", "pattern", data),
        },
      },
    },
  ];
};
